import { api } from './api';
import type {
  CreateVersionPayload,
  TemplateDetail,
  TemplateSummary,
  TemplateVersion,
  TestPayload,
  TestResult,
} from '@/types/template';

export const templatesApi = {
  list: () => api.get<TemplateSummary[]>('/templates'),
  get: (id: string) => api.get<TemplateDetail>(`/templates/${id}`),
  createVersion: (id: string, payload: CreateVersionPayload) =>
    api.post<TemplateVersion>(`/templates/${id}/versions`, payload),
  activateVersion: (id: string, versionId: string) =>
    api.post<{ activated: boolean }>(`/templates/${id}/activate-version/${versionId}`),
  test: (id: string, payload: TestPayload) =>
    api.post<TestResult>(`/templates/${id}/test`, payload),
};
